import * as _uniq from 'lodash/uniq';

export function uniq(values: any[]): any[] {
  return _uniq(values);
}
